module.exports = __webpack_public_path__ + "static/img/light-theme.4183aad0.svg";